var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.exportarExcel }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Exportar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_fecha",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizada")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo_fecha" } }, [
                  _vm._v("Tipo de fecha")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      disabled: _vm.form.tipo_fecha !== "P",
                      id: "desde",
                      locale: "es",
                      "no-label": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD HH:mm",
                      formatted: "YYYY-MM-DD HH:mm",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.desde,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desde", $$v)
                      },
                      expression: "form.desde"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Desde")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      disabled: _vm.form.tipo_fecha !== "P",
                      id: "hasta",
                      locale: "es",
                      "no-label": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD HH:mm",
                      formatted: "YYYY-MM-DD HH:mm",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.hasta,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "hasta", $$v)
                      },
                      expression: "form.hasta"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Hasta")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              {
                staticClass: "form-field select2",
                class: { "select2--disabled": !_vm.administraTodasBodegas }
              },
              [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "bodegas",
                        placeholder: "Seleccione...",
                        options: _vm.optionsBodegas,
                        label: "descripcion"
                      },
                      on: { input: _vm.inputBodegas },
                      model: {
                        value: _vm.selectedBodegas,
                        callback: function($$v) {
                          _vm.selectedBodegas = $$v
                        },
                        expression: "selectedBodegas"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bodegas" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.administraTodasBodegas ? "Bodega(s)" : "Bodega"
                        )
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-8" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "items",
                      multiple: "",
                      options: _vm.items,
                      label: "nombre"
                    },
                    on: { search: _vm.searchItems, input: _vm.inputItems },
                    model: {
                      value: _vm.selectedItems,
                      callback: function($$v) {
                        _vm.selectedItems = $$v
                      },
                      expression: "selectedItems"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "items" } }, [_vm._v("Ítem(s)")])
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _c(
        "div",
        { staticClass: "card__content" },
        _vm._l(_vm.saldosFinales, function(item, index) {
          return _c("item-kardex", {
            key: index,
            attrs: {
              tipo_fecha: _vm.form.tipo_fecha,
              bodegas_id: _vm.form.bodegas_id,
              desde: _vm.form.desde,
              hasta: _vm.form.hasta,
              saldosFinales: item.saldos,
              saldosIniciales: _vm.obtenerSaldosIniciales(item),
              itemId: item.item.item_id,
              descripcionItem: item.item.descripcion_item
            }
          })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Kardex")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e781112", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e781112","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/Kardex.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6e781112","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/Kardex.vue
// module chunks = 0